<template>
  <div class="page-default page-drone">
    <div class="row m-0 page-section">
      <div
        class="col col-md-4 col-lg-3 section-left"
        :class="{ show: showSidebar }"
      >
        <div class="case-container border-outline-light">
          <div class="case-header text-capitalize">
            <div
              class="d-flex justify-content-center align-items-center"
              :class="{ invisible: videos.length < 1 }"
            >
              Page
              <input
                class="form-control form-control-default form-control-sm text-center mx-1 px-0"
                style="width: 28px; font-size: 90%"
                v-model="inputPage"
                type="number"
                :disabled="totalPage <= 1"
                @keydown.enter="changePage(inputPage)"
                @blur="changePage(inputPage)"
                title="Enter number of page"
                data-toggle="tooltip"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              />
              <p class="mb-0 text-nowrap">/ {{ totalPage }}</p>
              <div class="btn-group ml-2">
                <button
                  class="btn btn-light btn-sm"
                  title="Previous page"
                  :disabled="currentPage <= 1"
                  @click="changePage(currentPage - 1)"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  &#8249;
                </button>
                <button
                  class="btn btn-light btn-sm"
                  title="Next page"
                  :disabled="currentPage >= totalPage"
                  @click="changePage(currentPage + 1)"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  &#8250;
                </button>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <div class="dropdown">
                <button
                  class="btn btn-link btn-sm dropdown-toggle position-relative"
                  :class="{ 'btn-primary': currentReviewStatus }"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  title="Filter by status"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  <span>
                    <font-awesome-icon
                      :icon="['fas', 'clipboard-list']"
                      :class="{ 'text-light': currentReviewStatus }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-white rounded-circle"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 0.25em;
                        right: 0.25em;
                      "
                      v-if="currentReviewStatus"
                    />
                  </span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right p-0"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 200px; overflow-y: auto"
                >
                  <button
                    v-for="status in reviewStatuses"
                    :key="`reviewStatus-${status.value || 'all'}`"
                    class="dropdown-item d-flex justify-content-between align-items-center px-3 py-2 fs-8 btn-secondary border-outline-light-bottom"
                    :class="
                      currentReviewStatus == status.value
                        ? ' text-primary'
                        : ' '
                    "
                    @click="currentReviewStatus = status.value"
                  >
                    {{ status.label }}
                    <font-awesome-icon
                      :icon="['fas', 'check']"
                      class="text-primary ml-3 small"
                      v-if="currentReviewStatus == status.value"
                    />
                  </button>
                </div>
              </div>
              <div
                class="dropdown ml-2"
                v-if="
                  userRole == 'Supervisor'
                    ? userDistricts.length > 1
                    : allDistricts.length > 1
                "
              >
                <button
                  class="btn btn-link btn-sm dropdown-toggle position-relative"
                  :class="{ 'btn-primary': currentDistrict }"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  title="Filter by district"
                  data-placement="bottom"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  <span>
                    <font-awesome-icon
                      :icon="['fas', 'filter']"
                      :class="{ 'text-light': currentDistrict }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-white rounded-circle"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 0.25em;
                        right: 0.25em;
                      "
                      v-if="currentDistrict"
                    />
                  </span>
                </button>
                <div
                  class="dropdown-menu dropdown-menu-right p-0"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 200px; overflow-y: auto"
                >
                  <button
                    class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center px-3 py-2 fs-8 btn-secondary border-outline-light-bottom"
                    :class="currentDistrict == null ? ' text-primary' : ' '"
                    @click="currentDistrict = null"
                  >
                    All districts
                    <font-awesome-icon
                      :icon="['fas', 'check']"
                      class="text-primary ml-3 small"
                      v-if="currentDistrict == null"
                    />
                  </button>
                  <button
                    v-for="district in userDistricts.length
                      ? userDistricts
                      : allDistricts"
                    :key="district._id"
                    class="dropdown-item d-flex justify-content-between align-items-center px-3 py-2 fs-8 btn-secondary border-outline-light-bottom"
                    :class="currentDistrict == district ? ' text-primary' : ' '"
                    @click="currentDistrict = district"
                  >
                    {{ district.name }}
                    <font-awesome-icon
                      :icon="['fas', 'check']"
                      class="text-primary ml-3 small"
                      v-if="
                        currentDistrict && currentDistrict._id == district._id
                      "
                    />
                  </button>
                </div>
              </div>
              <div class="dropdown ml-2">
                <button
                  class="btn btn-link btn-sm dropdown-toggle position-relative"
                  :class="{ 'btn-primary': currentRoad }"
                  type="button"
                  id="dropdownMenuButton"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  title="Filter by road"
                  data-placement="bottom"
                  :disabled="!currentDistrict"
                  @mouseover="helper.showTooltip"
                  @mouseleave="helper.hideTooltip"
                >
                  <span>
                    <font-awesome-icon
                      :icon="['fas', 'road']"
                      :class="{ 'text-light': currentRoad }"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-white rounded-circle"
                      style="
                        font-size: 0.85em;
                        position: absolute;
                        top: 0.25em;
                        right: 0.25em;
                      "
                      v-if="currentRoad"
                    />
                  </span>
                </button>
                <div
                  class="dropdown-menu p-0"
                  aria-labelledby="dropdownMenuButton"
                  style="max-height: 200px; width: 250px; overflow-y: auto"
                >
                  <input
                    type="text"
                    v-model="roadSearch"
                    class="form-control border-0"
                    placeholder="Search road"
                    aria-label="Search road"
                  />
                  <button
                    class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center px-3 py-2 fs-8 btn-secondary border-outline-light-bottom"
                    :class="currentRoad == null ? ' text-primary' : ' '"
                    @click="currentRoad = null"
                  >
                    All roads
                    <font-awesome-icon
                      :icon="['fas', 'check']"
                      class="text-primary ml-3 small"
                      v-if="currentRoad == null"
                    />
                  </button>
                  <button
                    v-for="road in filterRoads"
                    :key="road._id"
                    class="dropdown-item text-wrap d-flex justify-content-between align-items-center px-3 py-2 fs-8 btn-secondary border-outline-light-bottom"
                    :class="currentRoad == road ? ' text-primary' : ' '"
                    @click="currentRoad = road"
                  >
                    {{ road.name }}
                    <font-awesome-icon
                      :icon="['fas', 'check']"
                      class="text-primary ml-3 small"
                      v-if="currentRoad && currentRoad._id == road._id"
                    />
                  </button>
                </div>
              </div>
              <button
                class="btn btn-link btn-sm position-relative ml-2"
                :class="{ 'btn-primary': dateRange }"
                type="button"
                @click="showDateSelector = true"
                title="Filter by date"
                data-toggle="tooltip"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <span>
                  <font-awesome-icon
                    :icon="['far', 'calendar-alt']"
                    :class="{ 'text-light': dateRange }"
                  />
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="text-success bg-white rounded-circle"
                    style="
                      font-size: 0.85em;
                      position: absolute;
                      top: 0.25em;
                      right: 0.25em;
                    "
                    v-if="dateRange"
                  />
                </span>
              </button>
              <div
                class="case-header-icon clickable ml-4 d-block d-md-none"
                @click="toggleSidebar()"
                title="Click to close sidebar"
                data-toggle="tooltip"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon :icon="['fas', 'times']" />
              </div>
            </div>
          </div>
          <div
            class="case-body rounded-0"
            style="height: calc(100% - 43px - 36px)"
          >
            <div
              id="projectsListContainer"
              class="projects-list-container h-100"
            >
              <div
                class="case-list border-bottom"
                :id="video._id"
                :data-codec="video.videoCodec || 'not-specified'"
                v-for="video in videos"
                :key="video._id"
                :class="{
                  active: currentVideo && currentVideo._id == video._id,
                }"
                @click="goTo(video._id)"
              >
                <p class="small text-muted mb-0">
                  #{{ video.index }} {{ video.district && video.district.name }}
                </p>
                <p class="font-weight-bold mb-0 text-dark">
                  {{ formatDate(video.datetime) }}
                </p>
                <p class="small mb-1" v-if="video.road">
                  {{ video.road.name }},<br />
                  {{ video.road.subdistrict }},
                  {{ video.road.district }}
                </p>
                <p class="small text-muted mb-1">
                  <span
                    class="mr-2"
                    v-if="
                      video.isProcessed &&
                      filteredDefects(video.defects) &&
                      filteredDefects(video.defects).length > 0
                    "
                  >
                    {{
                      filteredDefects(video.defects).length > 0
                        ? filteredDefects(video.defects).length
                        : "No"
                    }}
                    Defects found
                  </span>
                  <template v-else-if="!video.isProcessed">
                    <div class="spinner-border spinner-border-xs mr-1"></div>
                    Processing...
                  </template>
                  <span
                    class="mb-0 badge badge-success"
                    v-if="video.isProcessed && video.isReviewed"
                  >
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="mr-1 bg-white rounded-circle"
                    />Reviewed
                  </span>
                </p>
                <p class="small text-muted mb-0 user-select-none">
                  <font-awesome-icon
                    :icon="['fas', 'video']"
                    class="mr-2 text-primary"
                    @click.stop
                    @dblclick.stop="deleteVideo(video)"
                  />Drone
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-if="videos.length > 0"
              >
                <p class="mb-0 font-italic text-muted">
                  End of
                  {{
                    currentPage == totalPage ? "list" : `page ${currentPage}`
                  }}
                </p>
              </div>
              <div
                class="p-4 d-flex justify-content-center align-items-center"
                v-else
              >
                <p class="mb-0 font-italic text-muted">No drone video found</p>
              </div>
            </div>
          </div>
          <div class="case-footer row mx-0">
            <div
              class="col-6 px-0 small d-flex flex-column justify-content-center align-items-center text-muted"
              style="line-height: 1.1"
            >
              <small>
                <span class="font-weight-medium mr-2">
                  {{ totalVideoCount }}
                </span>
                <span>videos</span>
              </small>
              <!-- <small class="text-warning">
                <small v-if="isLoadingDefectCount">
                  <div
                    class="spinner-border spinner-border-sm mr-2"
                    role="status"
                    style="width: 0.6rem; height: 0.6rem"
                  ></div>
                </small>
                <span class="font-weight-medium mr-2" v-else>
                  {{ totalDefectCount }}
                </span>
                <span>defects</span>
              </small> -->
            </div>
            <div class="col-6 px-0">
              <button
                class="btn btn-block btn-sm btn-primary py-2 rounded-0"
                @click="showMediaUploader = true"
                title="Click to upload"
                data-toggle="tooltip"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon :icon="['fas', 'upload']" class="mr-2" />
                Upload
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col section-right text-truncate d-flex px-0 px-md-3">
        <div class="case-container border-outline-light w-100">
          <div class="section-header border-bottom border-outline-light">
            <button
              class="btn btn-outline-primary shadow-sm mr-3 section-left-toggler"
              @click="toggleSidebar()"
              title="Click to open sidebar"
              data-toggle="tooltip"
              data-placement="bottom"
              @mouseover="helper.showTooltip"
              @mouseleave="helper.hideTooltip"
            >
              <font-awesome-icon :icon="['fas', 'angle-right']" />
            </button>
            <div
              v-if="currentVideo"
              class="w-100 d-flex justify-content-between align-items-center"
            >
              <div>
                <div class="text-uppercase">
                  <font-awesome-icon
                    :icon="['fas', 'video']"
                    class="mr-2 text-primary"
                  />
                  {{ formatDate(currentVideo.datetime) }}
                  <span class="" v-if="currentVideo.district">
                    &middot;
                    {{ currentVideo.district.name }}
                  </span>
                </div>
                <p
                  class="small text-muted mb-0 d-none d-md-block"
                  v-if="currentVideo.roadName"
                >
                  {{ currentVideo.roadName }}
                </p>
              </div>
              <div
                class="small text-capitalize text-muted"
                v-if="!currentVideo.isProcessed"
              >
                <div
                  class="spinner-border spinner-border-sm text-primary mr-1"
                ></div>
                Processing...
              </div>
              <div v-else class="small text-right">
                <p class="mb-1">
                  {{ filteredDefects(currentVideo.defects).length }} Defects
                  found
                </p>
                <button
                  class="btn btn-primary btn-sm py-0"
                  @click="setAsReviewed()"
                  v-if="!currentVideo.isReviewed"
                >
                  <small>Set as Reviewed</small>
                </button>
                <p class="mb-0 badge badge-success" v-else>
                  <font-awesome-icon
                    :icon="['fas', 'check-circle']"
                    class="mr-1 bg-white rounded-circle"
                  />Reviewed
                </p>
              </div>
            </div>
            <p
              v-else
              class="font-weight-normal small mb-0 font-italic flex-grow-1 text-center"
            >
              No drone video selected
            </p>
          </div>
          <div
            id="reportBody"
            class="dashcam-body"
            :class="{
              'no-defect':
                currentVideo &&
                filteredDefects(currentVideo.defects).length < 1,
            }"
            v-if="currentVideo"
          >
            <div class="dashcam-video position-relative shadow-sm">
              <div
                class="dashcam-map border-outline-light"
                :class="{
                  invisible:
                    !currentVideo.coordinates ||
                    currentVideo.coordinates.length < 1,
                }"
              >
                <div
                  id="video-map"
                  class="h-100 w-100 rounded overflow-hidden"
                ></div>
              </div>
              <video
                :src="currentVideoSrc"
                crossorigin="anonymous"
                @timeupdate="videoPlaying"
                controls
                autoplay
                loop
                muted
                playsinline
              />
            </div>
            <div class="dashcam-footer" :class="{ expanded: footerExpanded }">
              <div class="d-flex border-bottom border-light">
                <div class="dropdown" style="width: 150px">
                  <button
                    class="btn btn-sm btn-block no-focus position-relative rounded-0 py-0 px-2 d-flex justify-content-between align-items-center overflow-hidden"
                    type="button"
                    id="dropdownFilterDefect"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    @click="
                      dropdownActive == 'filterDefect'
                        ? (dropdownActive = '')
                        : (dropdownActive = 'filterDefect')
                    "
                    @blur="dropdownActive = ''"
                    title="Filter by defect"
                    data-placement="bottom"
                    @mouseover="helper.showTooltip"
                    @mouseleave="helper.hideTooltip"
                  >
                    <div
                      class="d-flex justify-content-start align-items-center w-100 py-2"
                    >
                      <div class="mr-2">
                        <font-awesome-icon
                          class=""
                          :icon="['fas', 'hard-hat']"
                          :class="{ 'text-primary': filterDefect }"
                        />
                        <font-awesome-icon
                          :icon="['fas', 'check-circle']"
                          class="text-success bg-white rounded-circle"
                          style="
                            font-size: 0.85em;
                            position: absolute;
                            top: 1.55em;
                            right: 0.45em;
                          "
                          v-if="filterDefect"
                        />
                      </div>
                      <div
                        class="text-left overflow-hidden w-100"
                        style="line-height: 1.3"
                      >
                        <p class="small mb-0 text-muted">Filters</p>

                        <div
                          class="d-flex justify-content-between align-items-center"
                        >
                          <p class="mb-0 text-nowrap text-truncate">
                            {{
                              filterDefect
                                ? typeOfDefects.find(
                                    (type) => type.value == filterDefect
                                  ).label
                                : "All"
                            }}
                          </p>
                          <font-awesome-icon
                            v-if="dropdownActive == 'filterDefect'"
                            class="text-light mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-up']"
                          />
                          <font-awesome-icon
                            v-else
                            class="text-light mr-1 angle-icon"
                            style="font-size: 0.65rem"
                            :icon="['fas', 'angle-down']"
                          />
                        </div>
                      </div>
                    </div>
                  </button>
                  <div
                    class="dropdown-menu dropdown-menu-right p-0"
                    aria-labelledby="dropdownMenuButton"
                    style="max-height: 320px; overflow-y: auto"
                  >
                    <button
                      class="dropdown-item font-weight-medium d-flex justify-content-between align-items-center py-2 px-3 border-outline-light-bottom fs-8"
                      :class="filterDefect == null ? 'text-primary' : ''"
                      @click="filterDefect = null"
                    >
                      All Defects
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="filterDefect == null"
                      />
                    </button>
                    <button
                      v-for="type in typeOfDefects"
                      :key="`${type.value}`"
                      class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 btn-secondary border-outline-light-bottom fs-8"
                      :class="filterDefect == type.value ? 'text-primary' : ''"
                      @click="filterDefect = type.value"
                    >
                      {{ type.label }}
                      <font-awesome-icon
                        :icon="['fas', 'check']"
                        class="text-primary ml-3 small"
                        v-if="filterDefect == type.value"
                      />
                    </button>
                  </div>
                </div>
              </div>
              <button
                class="btn btn-sm btn-light rounded-circle btn-toggler"
                @click="footerExpanded = !footerExpanded"
                title="Click to view more"
                data-toggle="tooltip"
                data-placement="bottom"
                @mouseover="helper.showTooltip"
                @mouseleave="helper.hideTooltip"
              >
                <font-awesome-icon :icon="['fas', 'angle-down']" />
              </button>
              <div class="dashcam-defects show-scroll">
                <div v-for="defect in filterDefectByType" :key="defect._id">
                  <div class="img-container">
                    <img
                      :src="
                        defect.annotatedImage
                          ? helper.formatMediaUrl(defect.annotatedImage)
                          : helper.formatMediaUrl(defect.image)
                      "
                      @click="currentDefect = defect"
                      title="Click to view image"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                    />
                    <font-awesome-icon
                      :icon="['fas', 'check-circle']"
                      class="text-success bg-white rounded-circle"
                      style="position: absolute; top: 5px; right: 5px"
                      v-if="defect.case"
                    />
                    <button
                      class="btn btn-sm btn-danger"
                      style="
                        position: absolute;
                        top: 5px;
                        left: 5px;
                        font-size: 70%;
                      "
                      @click="deleteDefect(defect._id)"
                      title="Click to delete"
                      data-toggle="tooltip"
                      data-placement="bottom"
                      @mouseover="helper.showTooltip"
                      @mouseleave="helper.hideTooltip"
                    >
                      <font-awesome-icon :icon="['fas', 'trash-alt']" />
                    </button>
                  </div>
                  <div class="defect-info align-items-baseline">
                    <div
                      v-if="
                        !caseAction ||
                        (caseAction && caseAction.defect._id != defect._id)
                      "
                      class="d-flex justify-content-start align-items-center"
                    >
                      <small>{{ formatDate(defect.datetime) }}</small>
                    </div>
                    <div
                      class="action text-success py-2"
                      v-if="caseAction && caseAction.defect._id == defect._id"
                    >
                      <button
                        class="btn btn-link btn-sm"
                        @click="caseAction = null"
                        title="Click to cancel"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                      >
                        <small>Cancel</small>
                      </button>
                      <button
                        class="btn btn-link btn-sm"
                        :class="
                          caseAction.type == 'add'
                            ? 'text-success'
                            : 'text-danger'
                        "
                        @click="doCaseAction(caseAction.type, defect)"
                        title="Click to confirm"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                      >
                        <small class="font-weight-medium">Confirm</small>
                      </button>
                    </div>
                    <div class="input" v-else>
                      <a
                        title="Remove from case"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        v-if="defect.case"
                      >
                        <font-awesome-icon
                          :icon="['fas', 'minus']"
                          class="text-danger mr-1"
                          @click="removeFromCase(defect)"
                        />
                      </a>
                      <a
                        title="Add to case"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        @mouseover="helper.showTooltip"
                        @mouseleave="helper.hideTooltip"
                        v-else
                      >
                        <font-awesome-icon
                          :icon="['fas', 'plus']"
                          class="text-success mr-1"
                          @click="addToCase(defect)"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <spinner v-if="isProcessing" />
    <media-preview
      v-if="currentDefect"
      :url="
        currentDefect.annotatedImage
          ? helper.formatMediaUrl(currentDefect.annotatedImage)
          : helper.formatMediaUrl(currentDefect.image)
      "
      :subtitle="`Defect`"
      :title="`${formatDate(currentDefect.datetime)}`"
      :showMap="true"
      :defect="currentDefect"
      :showControl="{
        delete: true,
        add: currentDefect && !currentDefect.case,
        remove: currentDefect && currentDefect.case,
      }"
      :hasNavigation="{
        previous: getCurrentDefectIndex() > 0,
        next:
          getCurrentDefectIndex() <
          filteredDefects(currentVideo.defects).length - 1,
      }"
      @close="currentDefect = null"
      @delete="deleteDefect($event._id)"
      @add="doCaseAction('add', $event)"
      @remove="doCaseAction('remove', $event)"
      @navigate="navigateMediaPreview"
    />
    <media-uploader
      v-if="showMediaUploader"
      video-type="drone"
      :districts="userDistricts.length > 0 ? userDistricts : allDistricts"
      :districtFrom="userDistricts.length > 0 ? 'user' : 'all'"
      @uploaded="appendNewVideo"
      @close="showMediaUploader = false"
    />
    <road-selector
      v-if="showRoadSelector"
      :districts="userDistricts.length > 0 ? userDistricts : allDistricts"
      :videoDistrict="currentVideo && currentVideo.district"
      :lat="showRoadSelector && showRoadSelector.lat"
      :lng="showRoadSelector && showRoadSelector.lng"
      @close="roadSelected"
    />
    <date-selector
      v-if="showDateSelector"
      :dateRange="dateRange"
      :isRange="true"
      @close="dateSelected"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import Moment from "moment";
import API from "@/api";
import Helper from "@/helper";
import Spinner from "@/components/Spinner";
import MediaPreview from "@/components/MediaPreview";
import MediaUploader from "@/components/MediaUploader";
import RoadSelector from "@/components/RoadSelector";
import DateSelector from "@/components/DateSelector";
import "mapbox-gl";

export default {
  name: "drone",
  components: {
    Spinner,
    MediaPreview,
    MediaUploader,
    RoadSelector,
    DateSelector,
  },
  data() {
    return {
      helper: Helper,
      map: null,
      mapMarker: null,
      isProcessing: false,
      showSidebar: false,
      showRoadSelector: false,
      showDateSelector: false,
      showMediaUploader: false,
      videos: [],
      currentVideo: null,
      footerExpanded: false,
      currentDefect: null,
      caseAction: null,
      aiUser: null,
      userDistricts: [],
      userRole: null,
      allDistricts: [],
      roadSearch: null,
      updateVideoStatus: null,
      currentDistrict: null,
      currentRoad: null,
      dateRange: null,
      currentPage: 1,
      pageLimit: 100,
      totalPage: 1,
      inputPage: 1,
      totalVideoCount: 0,
      totalDefectCount: 0,
      isLoadingDefectCount: true,
      currentCategory: null,
      currentWorkscope: null,
      reviewStatuses: [
        {
          label: "All",
          value: null,
        },
        {
          label: "Reviewed",
          value: "reviewed",
        },
        {
          label: "Pending Review",
          value: "pending_reviewed",
        },
      ],
      currentReviewStatus: "pending_reviewed",
      typeOfDefects: [],
      filterDefect: null,
      dropdownActive: "",
      newVideoCount: 0,
    };
  },
  watch: {
    showMediaUploader: {
      handler() {
        if (!this.showMediaUploader && this.newVideoCount) {
          this.getVideos();
        }
      },
    },
    currentRoad: {
      handler() {
        this.roadSearch = null;

        this.getVideos();
      },
      immediate: false,
    },
    currentDistrict: {
      handler() {
        this.currentRoad = null;

        this.getVideos();
      },
      immediate: false,
    },
    currentReviewStatus: {
      handler() {
        this.getVideos();
      },
      immediate: false,
    },
    currentVideo: {
      handler() {
        if (this.currentVideo === null) return;

        let arrays = [];
        if (this.filteredDefects(this.currentVideo.defects).length == 0) {
          arrays.push({
            label: "Pothole",
            value: "pothole",
          });
        }
        this.filteredDefects(this.currentVideo.defects).forEach((element) => {
          if (arrays.length == 0) {
            arrays.push({ label: element.name, value: element.name });
          } else {
            if (!arrays.find((item) => item.value == element.name)) {
              arrays.push({ label: element.name, value: element.name });
            }
          }
        });
        this.typeOfDefects = arrays;
      },
    },
  },
  computed: {
    filterRoads() {
      let _roads = JSON.parse(
        JSON.stringify(this.currentDistrict?.roads || [])
      );

      if (this.roadSearch) {
        _roads = _roads.filter((r) =>
          r.name.toLowerCase().includes(this.roadSearch.toLowerCase())
        );
      }

      return _roads;
    },
    filterDefectByType() {
      if (this.filterDefect)
        return this.filteredDefects(this.currentVideo.defects).filter((item) =>
          item.name.includes(this.filterDefect)
        );
      else return this.filteredDefects(this.currentVideo.defects);
    },
    currentVideoSrc() {
      if (this.currentVideo) {
        return this.currentVideo.videoProcessed
          ? Helper.formatMediaUrl(this.currentVideo.videoProcessed)
          : Helper.formatMediaUrl(this.currentVideo.video);
      } else {
        return "";
      }
    },
  },
  methods: {
    filteredDefects(defects) {
      if (defects)
        return defects
          .filter(
            (defect) => defect.isVerified || typeof defect.case !== "undefined"
          )
          .filter((defect) => defect.isApproved);
      else return [];
    },

    deleteVideo(video) {
      if (!video || this.userRole != "Super Admin") return;

      Swal.fire({
        html: `Delete video #${video.index}?`,
        icon: "question",
        confirmButtonText: "Delete",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          await API.delete(`drone-videos/${video._id}`);

          this.videos = this.videos
            .filter((v) => v._id !== video._id)
            .map((v, index) => {
              v.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return v;
            });

          this.currentVideo = null;

          this.isProcessing = false;
        }
      });
    },

    setAsReviewed() {
      if (!this.currentVideo) return;

      Swal.fire({
        html: "Finish reviewing this video?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-success",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.put(`drone-videos/${this.currentVideo._id}`, {
            isReviewed: true,
          })
            .then(async () => {
              this.isProcessing = false;

              let video = this.videos.find(
                (v) => v._id == this.currentVideo._id
              );

              video.isReviewed = true;

              this.currentDefect = null;

              await this.getVideos();

              Swal.fire("", "Video marked as Reviewed", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error marking video", "error");
            });
        }
      });
    },
    scrollListToTop() {
      const container = document.getElementById("projectsListContainer");

      if (container) {
        container.scrollTo(0, 0);
      }
    },
    changePage(page) {
      const x = parseInt(page);

      if (x != this.currentPage) {
        if (x > this.totalPage || x < 1) {
          this.inputPage = this.currentPage;
        } else {
          this.currentPage = x;
          this.inputPage = x;
        }

        this.getVideos("changePage");
      }
    },
    videoPlaying(e) {
      if (
        this.currentVideo &&
        this.currentVideo.coordinates &&
        this.currentVideo.coordinates.length > 0
      ) {
        let currentTime = Math.floor(e.srcElement.currentTime);

        let currentCoord = this.currentVideo.coordinates[currentTime];

        if (currentCoord) {
          this.setMapCenter(currentCoord[1], currentCoord[0]);
        }
      }
    },
    async initMap() {
      return new Promise((resolve) => {
        if (this.map) {
          if (
            this.currentVideo &&
            this.currentVideo.coordinates &&
            this.currentVideo.coordinates.length > 0
          ) {
            this.setMapCenter(
              this.currentVideo.coordinates[0][1],
              this.currentVideo.coordinates[0][0],
              "jump"
            );
          }

          this.map.resize();

          resolve();
        } else {
          mapboxgl.accessToken = process.env.VUE_APP_MAPBOX_KEY;

          this.map = new mapboxgl.Map({
            container: "video-map",
            style: "mapbox://styles/mapbox/light-v11",
            zoom: 14,
            interactive: false,
          });

          this.map.addControl(
            new mapboxgl.NavigationControl({ class: "d-flex" })
          );

          this.map.on("load", () => {
            if (
              this.currentVideo &&
              this.currentVideo.coordinates &&
              this.currentVideo.coordinates.length > 0
            ) {
              this.setMapCenter(
                this.currentVideo.coordinates[0][1],
                this.currentVideo.coordinates[0][0],
                "jump"
              );
            }

            this.map.resize();

            resolve();
          });
        }
      });
    },
    async setMapCenter(lng, lat, type) {
      if (this.map) {
        if (this.mapMarker) {
          this.mapMarker.remove();

          this.mapMarker = null;
        }

        let el = document.createElement("div");

        el.className = "pin";

        this.mapMarker = new mapboxgl.Marker(el).setLngLat([lng, lat]);

        this.mapMarker.addTo(this.map);

        if (type == "jump") {
          this.map.setCenter([lng, lat]);
        } else {
          this.map.flyTo({
            center: [lng, lat],
            curve: 0.1,
            easing: function (t) {
              return t;
            },
            essential: true,
          });
        }
      }
    },
    getCurrentDefectIndex() {
      return this.filteredDefects(this.currentVideo.defects).findIndex(
        (defect) => defect._id == this.currentDefect._id
      );
    },
    navigateMediaPreview(e) {
      if (this.currentDefect && this.currentVideo) {
        const currentDefectIndex = this.getCurrentDefectIndex();

        if (e == "previous" && currentDefectIndex > 0) {
          this.currentDefect = null;

          this.$nextTick(() => {
            this.currentDefect = this.filteredDefects(
              this.currentVideo.defects
            )[currentDefectIndex - 1];
          });
        } else if (
          e == "next" &&
          currentDefectIndex <
            this.filteredDefects(this.currentVideo.defects).length - 1
        ) {
          this.currentDefect = null;

          this.$nextTick(() => {
            this.currentDefect = this.filteredDefects(
              this.currentVideo.defects
            )[currentDefectIndex + 1];
          });
        }
      }
    },
    dateSelected(e) {
      if (typeof e == "object") {
        this.dateRange = {
          start: Moment(e.start).format("YYYY-MM-DD"),
          end: Moment(e.end).format("YYYY-MM-DD"),
        };

        this.getVideos();
      } else if (typeof e == "boolean" && e == false) {
        this.dateRange = null;

        this.getVideos();
      }

      this.showDateSelector = null;
    },
    deleteDefect(id) {
      Swal.fire({
        html: "Confirm delete defect?",
        icon: "question",
        confirmButtonText: "Confirm",
        showCancelButton: true,
        buttonsStyling: false,
        reverseButtons: true,
        customClass: {
          confirmButton: "btn btn-sm btn-danger",
          cancelButton: "btn btn-sm btn-link",
          actions: "d-flex justify-content-between align-items-center",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.isProcessing = true;

          API.delete(`defects/${id}`)
            .then(() => {
              this.isProcessing = false;

              let video = this.videos.find(
                (v) => v._id == this.currentVideo._id
              );

              video.defects = this.filteredDefects(video.defects).filter(
                (d) => d._id != id
              );

              this.currentDefect = null;

              Swal.fire("", "Defect deleted", "success");
            })
            .catch((err) => {
              this.isProcessing = false;

              console.error(err);

              Swal.fire("", "Error deleting defect", "error");
            });
        }
      });
    },
    appendNewVideo(data) {
      if (data) this.newVideoCount += 1;
    },
    doCaseAction(type, defect) {
      if (type == "remove") {
        this.isProcessing = true;

        this.caseAction = false;

        API.delete(`cases/${defect.case}`)
          .then(() => {
            defect.case = null;

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;
          });
      } else if (type == "add") {
        let options = {};

        Helper.workCategories().forEach((category) => {
          let label = "";
          if (category === "Rutin") {
            label = "Routine";
          } else if (category === "Berkala_Pavemen") {
            label = "Periodic Pavement";
          } else if (category === "Berkala_Bukan_Pavemen") {
            label = "Periodic Non-Pavement";
          } else if (category === "Kecemasan") {
            label = "Emergency";
          } else if (category === "Agensi_Berkenaan") {
            label = "Relevant Agency";
          } else {
            label = category.split("_").join(" ");
          }

          options[category] = label;
        });

        let workScopes = [
          // "R01",
          "R09",
          // "R02",
          // "R03",
          // "R04",
          // "R05",
          // "R06",
          // "R07",
          // "R011",
        ];
        let workScopeOptions = {};
        workScopes.forEach((scope) => {
          let label = "";
          if (scope === "R09") {
            label = "Inspection";
          } else {
            label = scope;
          }
          workScopeOptions[scope] = label;
        });

        Swal.fire({
          title: "Select work category",
          showCancelButton: true,
          confirmButtonText: "Select",
          reverseButtons: true,
          input: "select",
          inputOptions: options,
          customClass: {
            confirmButton: "btn btn-sm btn-primary mx-2",
            cancelButton: "btn btn-sm btn-light mx-2",
            input: "custom-select",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.isConfirmed) {
            this.currentCategory = result.value;
            Swal.fire({
              title: "Select work scope",
              showCancelButton: true,
              confirmButtonText: "Select",
              reverseButtons: true,
              input: "select",
              inputOptions: workScopeOptions,
              customClass: {
                confirmButton: "btn btn-sm btn-primary mx-2",
                cancelButton: "btn btn-sm btn-light mx-2",
                input: "custom-select",
              },
              buttonsStyling: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                this.isProcessing = true;

                this.currentWorkscope = result.value;

                // this.showRoadSelector = defect;
                // console.log(this.currentVideo);

                const body = {
                  source: "agent",
                  type: "ai",
                  status: "received",
                  lat: defect.lat,
                  lng: defect.lng,
                  caption: `[Automated] ${defect.name} detected via Drone`,
                  timestamp: defect.datetime,
                  media: defect.annotatedImage
                    ? defect.annotatedImage._id
                    : defect.image._id,
                  user: "5f01ea9f2a516a6379e9880b", //this.aiUser,
                  road: null,
                  defect: defect._id,
                  district: this.currentVideo.district.id,
                  reportType: this.currentWorkscope,
                  contractor: "612c5e628487e623af876e8a", // SELGEM
                  category: this.currentCategory.split(" ").join("_"),
                };

                await API.post("cases", body)
                  .then((retVal) => {
                    let _defect = this.filteredDefects(
                      this.currentVideo.defects
                    ).find((_defect) => _defect._id == defect._id);

                    _defect.case = retVal.data._id;

                    this.isProcessing = false;
                  })
                  .catch((err) => {
                    console.error(err);

                    this.isProcessing = false;
                  });

                this.currentCategory = null;
                this.currentWorkscope = null;

                this.caseAction = false;
              } else {
                this.currentCategory = null;
                this.currentWorkscope = null;

                this.caseAction = false;
              }
            });
          } else {
            this.currentCategory = null;

            this.caseAction = false;
          }
        });
      }
    },
    async roadSelected(e) {
      const defect = { ...this.showRoadSelector };

      this.showRoadSelector = false;

      if (e) {
        this.isProcessing = true;

        const body = {
          source: "agent",
          type: "ai",
          status: "received",
          lat: defect.lat,
          lng: defect.lng,
          caption: `[Automated] ${defect.name} detected via Drone`,
          timestamp: defect.datetime,
          media: defect.annotatedImage
            ? defect.annotatedImage._id
            : defect.image._id,
          user: "5f01ea9f2a516a6379e9880b", //this.aiUser,
          road: e._id,
          defect: defect._id,
          district: e.daerah,
          reportType: this.currentWorkscope,
          contractor: "612c5e628487e623af876e8a", // SELGEM
          category: this.currentCategory.split(" ").join("_"),
        };

        await API.post("cases", body)
          .then((retVal) => {
            let _defect = this.filteredDefects(this.currentVideo.defects).find(
              (_defect) => _defect._id == defect._id
            );

            _defect.case = retVal.data._id;

            this.isProcessing = false;
          })
          .catch((err) => {
            console.error(err);

            this.isProcessing = false;
          });
      }

      this.currentCategory = null;
      this.currentWorkscope = null;

      this.caseAction = false;
    },
    addToCase(defect) {
      this.caseAction = { type: "add", defect };
    },
    removeFromCase(defect) {
      this.caseAction = { type: "remove", defect };
    },
    formatDate(date) {
      if (!date) {
        return "";
      } else {
        return Moment(date).format("D MMM YYYY, h:mm A");
      }
    },
    toggleSidebar() {
      this.showSidebar = !this.showSidebar;
    },
    async goTo(id) {
      this.footerExpanded = false;

      this.showSidebar = false;

      this.showMediaUploader = false;

      this.currentDefect = null;

      this.caseAction = null;

      let _currentVideo = this.videos.find((video) => video._id == id);

      if (
        _currentVideo &&
        _currentVideo.coordinates &&
        _currentVideo.coordinates.length > 0
      ) {
        _currentVideo.coordinates = _currentVideo.coordinates.filter(
          (_, index) => index % 2 !== 0
        );
      }

      if (
        _currentVideo &&
        !_currentVideo.roadName &&
        this.filteredDefects(_currentVideo.defects) &&
        this.filteredDefects(_currentVideo.defects).length > 0
      ) {
        const defectWithRoad = this.filteredDefects(_currentVideo.defects).find(
          (defect) => defect.road
        );

        if (defectWithRoad) {
          _currentVideo.roadName = await this.getRoadName(defectWithRoad.road);
        }
      } else if (!_currentVideo.roadName) {
        _currentVideo.roadName = await this.getRoadnameFromGMaps(_currentVideo);
      }

      this.currentVideo = _currentVideo;

      this.$nextTick(() => {
        this.initMap();
      });
    },
    getRoadnameFromGMaps(_currentVideo) {
      return new Promise(async (resolve) => {
        if (!_currentVideo.coordinates || _currentVideo.coordinates.length < 1)
          return resolve(null);

        const coords = _currentVideo.coordinates[0];

        if (coords[0] && coords[1]) {
          const retVal = await API.get(
            `dashcamvideos/road?lat=${coords[0]}&lng=${coords[1]}`
          );

          resolve(retVal.data.roadName);
        } else {
          resolve("");
        }
      });
    },
    async getRoadName(id) {
      return API.get(`roads/${id}`)
        .then((retVal) => {
          return retVal.data.name;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async getTotalVideoCount() {
      return API.get(this.droneEndpoint("count"))
        .then((retVal) => {
          this.totalVideoCount = retVal.data;

          return;
        })
        .catch((err) => {
          console.error(err);

          return;
        });
    },
    droneEndpoint(type) {
      let url = type == "count" ? "drone-videos/count?" : "drone-videos?";

      if (this.dateRange) {
        const start = Moment(this.dateRange.start).startOf("day").toISOString();
        const end = Moment(this.dateRange.end).endOf("day").toISOString();

        url += `datetime_gte=${start}&datetime_lte=${end}&`;
      }

      let _districts = this.userDistricts.length
        ? this.userDistricts
        : this.allDistricts;

      if (this.currentDistrict) {
        _districts = [this.currentDistrict];
      }

      _districts.forEach((district) => {
        url += `district_in=${district._id}&`;
      });

      if (this.currentRoad) {
        url += `road=${this.currentRoad._id}&`;
      }

      if (this.currentReviewStatus) {
        url += `isReviewed=${
          this.currentReviewStatus == "reviewed" ? true : false
        }&`;
      }

      if (type != "count") {
        url += `_sort=datetime:DESC&_limit=${this.pageLimit}&_start=${
          (this.currentPage - 1) * this.pageLimit
        }&`;
      }

      return url;
    },
    async getTotalDefectCount() {
      this.isLoadingDefectCount = true;

      const params = this.droneEndpoint()
        .replace("drone-videos?", "")
        .split("&")
        .filter((e) => e)
        .map((e) => e.split("="));

      const paramsObj = params.reduce(
        (acc, curr) => (
          curr[0].endsWith("_in")
            ? acc[curr[0]]?.length
              ? acc[curr[0]].push(curr[1])
              : (acc[curr[0]] = [curr[1]])
            : (acc[curr[0]] = curr[1]),
          acc
        ),
        {}
      );

      delete paramsObj["_sort"];
      delete paramsObj["_start"];
      paramsObj["_limit"] = -1;

      const queryArr = [];

      Object.keys(paramsObj).forEach((key) => {
        if (typeof paramsObj[key] == "object") {
          paramsObj[key].forEach((element) => {
            queryArr.push(`${key}=${element}`);
          });
        } else {
          queryArr.push(`${key}=${paramsObj[key]}`);
        }
      });

      await API.get(`drone-videos/count/defects?${queryArr.join("&")}`).then(
        (retVal) => {
          this.totalDefectCount = retVal.data;

          this.isLoadingDefectCount = false;
        }
      );

      return;
    },
    async getVideos(type) {
      this.newVideoCount = 0;

      if (type != "update") {
        this.isProcessing = true;
      }

      if (type != "update" && type != "changePage") {
        if (this.map) {
          this.map.remove();

          this.map = null;
        }

        this.currentVideo = null;
      }

      if (type != "changePage") {
        this.currentPage = 1;
        this.inputPage = 1;

        if (type != "changePage") {
          this.currentPage = 1;
          this.inputPage = 1;
        }
      }

      await this.getTotalVideoCount();

      if (type != "update" && type != "changePage") {
        this.getTotalDefectCount();
      }

      return await API.get(this.droneEndpoint())
        .then((retVal) => {
          if (type == "update") {
            this.videos = this.videos.map((video, index) => {
              const _video = retVal.data.find((data) => data._id == video._id);

              if (_video) {
                video = _video;
              }

              video.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return video;
            });
          } else {
            this.videos = retVal.data.length > 0 ? retVal.data : [];

            this.videos = this.videos.map((v, index) => {
              v.index = (this.currentPage - 1) * this.pageLimit + index + 1;

              return v;
            });

            if (this.videos.length > 0) {
              this.goTo(this.videos[0]._id);
            }

            this.totalPage = Math.ceil(this.totalVideoCount / this.pageLimit);

            this.$nextTick(() => {
              this.scrollListToTop();

              this.isProcessing = false;
            });
          }

          if (this.updateVideoStatus) {
            clearInterval(this.updateVideoStatus);
          }

          this.updateVideoStatus = setInterval(() => {
            this.getVideos("update");
          }, 30000);
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getAIUser() {
      this.isProcessing = true;

      return await API.get("users?username=Infrasel AI")
        .then((retVal) => {
          this.aiUser = retVal.data.length > 0 ? retVal.data[0]._id : null;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getAllDistricts() {
      this.isProcessing = true;

      return await API.get("districtsOnly?_sort=name")
        .then((retVal) => {
          this.allDistricts = retVal.data;

          this.isProcessing = false;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;
        });
    },
    async getDistrictRoads(districtIds) {
      this.isProcessing = true;

      let url = "roadsOnly";

      if (districtIds && districtIds.length > 0) {
        url += `?daerah_in=${districtIds.join("&daerah_in=")}&_limit=-1`;
      }

      return await API.get(url)
        .then((retVal) => {
          this.isProcessing = false;

          return retVal.data;
        })
        .catch((err) => {
          console.error(err);

          this.isProcessing = false;

          return null;
        });
    },
  },
  async mounted() {
    this.newVideoCount = 0;

    let _user = localStorage.getItem("user");

    if (_user) {
      _user = JSON.parse(_user);

      if (_user.districts && _user.districts.length > 0) {
        this.userDistricts = _user.districts;

        // const userRoads = await this.getDistrictRoads(
        //   _user.districts.map((d) => d._id)
        // );

        // this.userDistricts.forEach((district) => {
        //   district.roads = userRoads.filter(
        //     (road) => road.daerah._id == district._id
        //   );
        // });
      }
      this.userDistricts = _user.districts ? _user.districts : [];
      this.userRole = _user.role.name;
    }

    await this.getAllDistricts();
    await this.getVideos();
  },
  beforeDestroy() {
    if (this.map) {
      this.map.remove();

      this.map = null;

      this.mapMarker = null;
    }

    if (this.updateVideoStatus) {
      clearInterval(this.updateVideoStatus);
    }
  },
};
</script>

<style lang="scss" scoped>
.dashcam-map {
  top: 1rem;
  right: 1rem;
  max-height: 45%;
  max-width: 45%;
  width: 400px;
  height: 240px;
}
</style>